import { useRouteTransitionBlockerLegacy } from '@ipfabric/ui-components/LeaveDialog/useRouteTransitionBlocker';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import type { Transition } from 'history';
import { useState } from 'react';

export interface LeaveRouteHook {
  blocked: boolean;
  cancel: () => void;
  leave: () => void;
}

export const useLeaveRoute = (
  preventRouteLeave: boolean,
  /**
   * Callback is intended for some heavy computation right before transition is blocked
   * and will be used only if preventRouteLeave is true.
   * If this callback returns true, transition will be blocked but if it returns false
   * transition will not be blocked even preventRouteLeave is set true.
   * If you dont do any heavy computation use preventRouteLeave only.
   */
  shouldBlockTransitionExtensiveCheck?: () => boolean,
): LeaveRouteHook => {
  const [blocked, setBlocked] = useState(false);
  const [transition, setTransition] = useState<Transition | null>(null);

  const leave = () => {
    transition?.retry();
    setTransition(null);
  };

  const cancel = () => {
    setBlocked(false);
    setTransition(null);
  };

  const handleBlock = useStableCallback((tx: Transition) => {
    const shouldBlockTransition = shouldBlockTransitionExtensiveCheck?.();
    if (shouldBlockTransition === false) {
      tx.retry();
    } else {
      setTransition(tx);
      setBlocked(true);
    }
  });

  useRouteTransitionBlockerLegacy(handleBlock, preventRouteLeave);

  return {
    blocked,
    cancel,
    leave,
  };
};
